var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsFacebookNewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.07C2 23.035 7.04 28.804 13.69 30l.083-.068a.564.564 0 01-.013-.002v-9.92h-3.5v-3.94h3.5v-3.095c0-3.518 2.24-5.487 5.46-5.487.98 0 2.1.14 3.08.28v3.589h-1.82c-1.68 0-2.1.844-2.1 1.97v2.743h3.71l-.63 3.94h-3.08v9.92l-.128.022.058.048C24.96 28.804 30 23.035 30 16.07 30 8.332 23.7 2 16 2S2 8.332 2 16.07z",
    fill: "url(#icon_sns_facebook_new_filled_svg__paint0_linear_37861_449404)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_sns_facebook_new_filled_svg__paint0_linear_37861_449404",
    x1: 16.001,
    y1: 29.162,
    x2: 16.001,
    y2: 1.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}

export default SvgIconSnsFacebookNewFilled;